import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { useUser } from '@/data/User';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsPerson } from 'integration/generated/transactions';
import { useGetUserInterests } from 'integration/hooks/useGetUserInterests';
import { useCallback, useMemo } from 'react';

const fetcherPersonUpdatePreferences =
	(pub: boolean) =>
	async (
		storeId: string,
		selected: { parentId: number; children: number[] }[],
		params: Record<string, unknown>
	) =>
		await transactionsPerson(pub).personUpdatePreferences(storeId, { selected }, params);

export const useUserInterests = () => {
	const router = useNextRouter();
	const params = useExtraRequestParameters();
	const { settings: rootSettings } = useSettings();
	const { storeId } = getClientSideCommon(rootSettings, router);
	const { user } = useUser();

	const isUserLoggedIn = useMemo(() => !!user?.isLoggedIn, [user]);

	const userInterestsQuery = useGetUserInterests(isUserLoggedIn);

	const onUpdateUserInterests = useCallback(
		async (body: { parentId: number; children: number[] }[]) => {
			await fetcherPersonUpdatePreferences(true)(storeId, body, params);
			await userInterestsQuery.mutate();
		},
		[userInterestsQuery, params, storeId]
	);

	return {
		userInterests: userInterestsQuery.data || [],
		isLoadingUserInterests: userInterestsQuery.isLoading,
		isUserLoggedIn,
		onUpdateUserInterests,
	};
};
